/*
 *  capsulation of http request,use 'fly',vue-resource alternative
 *  see detail in https://github.com/wendux/fly
 */
import Fly from 'flyio/dist/npm/fly'
import env from '@/env'
import config from '@/config'
import oAuth from '@/utils/oAuth'
import getSign from '@/utils/getSign'
const fly = new Fly()
fly.config.baseURL = env.host + env.baseURL
fly.config.withCredentials = true
// request setting
fly.interceptors.request.use(async function (request) {
  const storageType = process.env.VUE_APP_STORAGE_TYPE || 'localStorage'
  const tokenText = env.token || config.jwtConfig.token || 'token'
  const tokenTypeText =
    env.tokenType || config.jwtConfig.tokenType || 'tokenType'
  const token = window[storageType].getItem(tokenText)
  const tokenType = window[storageType].getItem(tokenTypeText) || 'Bearer'
  console.log(token)
  if (!token) {
    // do something like oAuth
    await oAuth()
    return request
  } else {
    if (request.method === 'POST') {
      if (!request.body) {
        request.body = {}
      }
      request.headers.sign = getSign(JSON.stringify(request.body))
    }
    request.headers.Authorization = `${tokenType} ${token}`
    return request
  }
})
fly.interceptors.response.use(
  async function (config, promise) {
    return config
  },
  async function (error, promise) {
    if (error.status === 401) {
      // console.log(localStorage.getItem('inrice_access_token'))
      // 如果此时有token,清除token
      console.log('need login')
      await oAuth()
      // do some thing like oAuth
      return promise.reject(error)
    } else {
      // 其他请求,直接抛出让业务去处理
      return promise.reject(error)
    }
  }
)

export default fly
